import dayjs from 'dayjs';
import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const reportsApi = {
  /* get: userReport */
  userReport: async (
    token,
    page = 1,
    limit = 20,
    startDate = dayjs().format('YYYY-MM-DD'),
    endDate = dayjs().format('YYYY-MM-DD')
  ) => {
    const queryStartDate = startDate ? `&date=${startDate}` : '';
    const queryEndDate = endDate ? `&endDate=${endDate}` : '';
    const response = await apiFetch(
      `${BASE_URL}/reports/user-reports?page=${page}&limit=${limit}${queryStartDate}${queryEndDate}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    const data = await response.json();
    return { status: response.status, data };
  },
  gameReportSummary: async (
    token,
    page = 1,
    limit = 20,
    startDate = dayjs().format('YYYY-MM-DD'),
    endDate = dayjs().format('YYYY-MM-DD'),
    gameId = ''
  ) => {
    const queryStartDate = startDate ? `&date=${startDate}` : '';
    const queryEndDate = endDate ? `&endDate=${endDate}` : '';
    const response = await apiFetch(
      `${BASE_URL}/reports/games-summary?page=${page}&limit=${limit}${queryStartDate}${queryEndDate}${
        gameId ? `&gameId=${gameId}` : ''
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    const data = await response.json();
    return { status: response.status, data };
  },
  gameReport: async (
    token,
    page = 1,
    limit = 20,
    startDate = dayjs().format('YYYY-MM-DD'),
    endDate = dayjs().format('YYYY-MM-DD'),
    gameId = ''
  ) => {
    const queryStartDate = startDate ? `&date=${startDate}` : '';
    const queryEndDate = endDate ? `&endDate=${endDate}` : '';
    const response = await apiFetch(
      `${BASE_URL}/reports/games-reports?page=${page}&limit=${limit}${queryStartDate}${queryEndDate}${
        gameId ? `&gameId=${gameId}` : ''
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    const data = await response.json();
    return { status: response.status, data };
  },
};
